import { Fragment } from "react";
import { EventCompletingPage } from "../event/EventCompletingPage";

export const Hompepage = () => {

    return (
        <Fragment>
            <EventCompletingPage />
        </Fragment >
    )
}